<div [formGroup]="form" class="py-2">
  <div class="flex justify-between gap-4 items-center">
      <mat-form-field
        class="input-tg mt-message-input w-3/12"
        appearance="outline"
      >
        <mat-label>Grau de parentesco</mat-label>
        <input matInput formControlName="typeContact" />
      </mat-form-field>
    <mat-form-field
      class="input-tg mt-message-input w-3/12"
      appearance="outline"
    >
      <mat-label>Nome</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>
    <mat-form-field
      class="input-tg mt-message-input w-2/12"
      appearance="outline"
    >
      <mat-label>Telefone</mat-label>
      <input [mask]="'(99) 99999-9999'" matInput formControlName="phone" />
    </mat-form-field>
    <mat-form-field
      class="input-tg mt-message-input w-3/12"
      appearance="outline"
    >
      <mat-label>Email</mat-label>
      <input matInput type="email" formControlName="email" />
    </mat-form-field>
    <mat-slide-toggle class="w-2/12" formControlName="active">
    <mat-label>Enviar alertas por email?</mat-label>
      {{
        form.get('active')?.value ? 'Ativo' : 'Inativo'
      }}</mat-slide-toggle>

    <button mat-flat-button class="btn-tg w-1/12" (click)="cancel()">
      Cancelar
    </button>
    @if (this.editItem.idCreate != undefined) {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="editContact()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Editar
        }
      </button>
    } @else {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="createContact()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Adicionar
        }
      </button>
    }
  </div>
</div>
